import { useApplySavedFilter, useNavigateWithContentFlush, useUser } from '@/hooks';
import { cn } from '@/lib/utils';
import { useSearchStore } from '@/store/searchStore.ts';
import { Button } from '@/components/ui/button';

const TAB_BASE = 'px-2 md:px-4 py-2 rounded-md text-sm font-medium';
const TAB_ACTIVE = 'bg-muted text-primary border-b-2 border-primary';
const TAB_INACTIVE = 'text-muted-foreground';

export function ExploreNavTabs() {
  const navigate = useNavigateWithContentFlush();
  const { data: memberContext } = useUser();
  const accountTabs = memberContext?.accountTabs || [];
  const tabFilters = memberContext?.tabFilters || [];
  const applySavedFilter = useApplySavedFilter();
  const { isCurrentTab, setInputValue, setQuery, clearActiveSavedFilter, isLayoutGlobal, isLayoutTabsSearching, activeSavedFilterName } = useSearchStore();

  const showFilterRow = isLayoutGlobal();

  const handleAddTabs = () => {
    navigate('/work4me/filters');
  };

  const addTabsButton = (
    <Button variant="outline" size="sm" onClick={handleAddTabs} className="py-2">
      Add Tabs
    </Button>
  );

  return (
    <div className="bg-muted/50 border-b">
      {/* Row of tabs, or the active filter row when searching all content */}
      <div data-testid="layout-tabs" className="flex flex-wrap items-center gap-1 px-2 md:px-4 py-1 bg-muted/50 border-none">
        {showFilterRow ? (
          <>
            <div data-testid="layout-filter-tab" className={cn(TAB_BASE, TAB_ACTIVE, 'cursor-default')}>
              Filter
            </div>
            <span className={cn(TAB_BASE, TAB_INACTIVE)}>
              {activeSavedFilterName !== null ? activeSavedFilterName : 'Global Search Activated'} - Searching all content
            </span>
            {accountTabs.length === 0 && addTabsButton}
          </>
        ) : accountTabs.length === 0 ? (
          addTabsButton
        ) : (
          accountTabs.map((tab) => (
          <div
            key={tab.value}
            data-testid={isCurrentTab(tab.searchFilter) ? 'layout-tab-active' : undefined}
            className={cn(
              TAB_BASE,
              'cursor-pointer',
              isCurrentTab(tab.searchFilter) ? TAB_ACTIVE : cn(TAB_INACTIVE, 'hover:bg-accent')
            )}
            onClick={() => {
              if (tab.searchFilter) {
                clearActiveSavedFilter();
                setQuery(tab.searchFilter);
                setInputValue(tab.searchFilter, navigate);
                return;
              }
              const filter = tabFilters.find((f) => f.id === tab.id);
              if (filter) {
                applySavedFilter(filter, navigate);
              }
            }}
          >
            <span className="block md:hidden">{tab.labelMobile}</span>
            <span className="hidden md:block">{tab.label}</span>
          </div>
        ))
        )}
      </div>

      {isLayoutTabsSearching() && (
        <div className="px-2 sm:px-4 pb-2 text-xs text-muted-foreground bg-muted/50 w-full">
          Tab Search Activated - Searching matching tabs
        </div>
      )}

    </div>
  );
}
